import { CheckmarkCircle } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

import { Trans } from '@lingui/react/macro';
import { NotificationBanner } from './NotificationBanner';

export const PairingCompleteNotification = () => {
  return (
    <div className="mb-16">
      <NotificationBanner>
        <CheckmarkCircle className="mr-16 text-feedback-green-500" size={32} />
        <Typography variant="body-md" fontWeight="bold" className="mr-8" as="p">
          <Trans>Pairing complete!</Trans>
        </Typography>
        <Typography variant="body-md" className="mr-8" as="p">
          <Trans>You&apos;ve successfully paired your device.</Trans>
        </Typography>
      </NotificationBanner>
    </div>
  );
};
